export type ApiMode = 'live' | 'test'

// Like Galaga, each deployment is bound to one API. Tokens cannot cross environments.
export const API_ENDPOINT = import.meta.env.VITE_API_ENDPOINT || 'https://api.thelocoapp.buzz/graphql'
export const API_MODE: ApiMode = /api\.thelocoapp\.(buzz|me|ninja)\//.test(API_ENDPOINT) ? 'test' : 'live'
export function endpointFor(_mode: ApiMode): string {
  return API_ENDPOINT
}
